import React from 'react';
import styles from '../IntradaySignalTestPage.module.css';
import { IntradaySignalFrequencyUnit } from '../../types/trading';
import { FrequencyFormState } from './signalConfig';

interface FrequencyControlsProps {
  value: FrequencyFormState;
  onChange: (next: FrequencyFormState) => void;
  fixedEvery?: number;
}

export const FrequencyControls: React.FC<FrequencyControlsProps> = ({
  value,
  onChange,
  fixedEvery,
}) => (
  <>
    <label className={styles.control}>
      <span>Every</span>
      <input
        value={fixedEvery ?? value.everyRaw}
        onChange={(e) => onChange({ ...value, everyRaw: e.target.value })}
        type="number"
        min={1}
        className={styles.input}
        disabled={fixedEvery !== undefined}
      />
    </label>
    <label className={styles.control}>
      <span>Unit</span>
      <select
        value={value.unit}
        onChange={(e) =>
          onChange({ ...value, unit: e.target.value as IntradaySignalFrequencyUnit })
        }
        className={styles.select}
      >
        <option value="seconds">Seconds</option>
        <option value="minutes">Minutes</option>
        <option value="hours">Hours</option>
      </select>
    </label>
  </>
);
